<template>
  <div>
    <Dialog :initialFocus="system_modal" as="div" class="relative z-100" @close="cancel">
      <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0" enter-to="opacity-100"
        leave="duration-200 ease-in" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-black/90" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div class="flex min-h-full items-center justify-center p-4 text-center">
          <TransitionChild as="template" enter="duration-300 ease-out absolute "
            enter-from="opacity-0 scale-95 bottom-full" enter-to="opacity-100 scale-100 bottom-[35%]"
            leave="duration-200 ease-in absolute" leave-from="opacity-100 scale-100 bottom-[35%]"
            leave-to="opacity-0 scale-95 bottom-full">
            <DialogPanel
              class="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-start align-middle shadow-xl transition-all">

              <DialogTitle as="h3" class="text-lg font-medium leading-6 text-gray-900">
                <!-- anumation here -->
              </DialogTitle>
              <!-- Dialog Content  -->
              <div class="" ref="system_modal">
                <section class=" text-dark-2 flex flex-col justify-center items-center">
                <img src="../../../assets/images/modals/email.png" alt="email icon" class="mb-6 max-w-[132px]" />
                  <p class="text-2xl ">{{t('messages.Email_Sent')}}</p>
                  <p class=" text-sm">{{ t('messages.verify_email_success')}}</p>
                </section>
              </div>
            </DialogPanel>
          </TransitionChild>

        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";


import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
} from '@headlessui/vue';

export default {
  name: "send-email-modal",
  components: {
    Dialog,
    DialogTitle,
    DialogPanel,
    TransitionChild,
  },
  emits: ["cancel"],

  setup(props, { emit }) {
    const system_modal = ref()
    const { t } = useI18n();

    const cancel = function () {
      emit('cancel')
    }
    onMounted(() => {
      setTimeout(() => {
        cancel()
      }, 5000);
    })
    return {
      t,
      system_modal,
      cancel,
    }
  }
}
</script>
<style lang="">
 
</style>